<template>
  <div :class="$style.box">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'preview',
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  min-height: 100%;
  background-color: #ededed;
}
</style>
